
/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    Shopify.theme.jsFeaturedCollectionsSlider = {
      init: function ($section) {
  
        // Add settings from schema to current object
        Shopify.theme.jsFeaturedCollectionsSlider = $.extend(this, Shopify.theme.getSectionData($section));
  
        let $sliderEl = $section.find('.is-slider-first [data-slider]');
        let $sliderCollEl = $section.find('[data-coll-slider]');
          this.createSlider($sliderEl,$section);
          this.collSlider($sliderCollEl, $section);
      },
      createSlider: function ($sliderEl,$section) {
        var thumbnails =  $sliderEl.find(".product__thumbnail ");
        var screenWidth = parseInt(screen.width);
        var slider_state = false;
        var thumbnails_length = parseInt(thumbnails.length);
        const slideData = {
          products_per_slide:parseInt( this.products_per),
          products_available: this.products_available,
          products_limit: this.products_limit,
          mobile_items_per_row: parseInt(this.mobile_items_per_row)
        }
        if(screenWidth > 799){
          if(thumbnails_length > slideData.products_per_slide ){
            slider_state = true;
          }
        }
        else{
          if(thumbnails_length > slideData.mobile_items_per_row ){
            slider_state = true;
          }
          console.log("slider_state mob",slider_state,slideData.mobile_items_per_row, thumbnails_length );
        }
        if(slider_state ){
          const slider = $sliderEl.flickity({
            lazyLoad: 2,
            freeScroll: true,
            imagesLoaded: true,
            draggable: true,
            cellAlign: 'center',
            wrapAround: false,
            pageDots: false,
            contain: true,
            prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
            initialIndex: 0,
            arrowShape: arrowShape,
            groupCells: true,
            selectedAttraction: 0.01,
            friction: 0.15
          });
          slider.on('settle.flickity', function () {
            slider.flickity('resize');
          });
          
          slider.on( 'scroll.flickity', function( event, progress ) {
            $progressBar = $section.find(".slider_progrssbar");
            progress = Math.max( 0, Math.min( 1, progress ) );
            $progressBar.width( progress * 100 + '%' );
          });
        }
  
      },
       collSlider: function ($sliderEl,$section) {
    
        const slider = $sliderEl.flickity({
          lazyLoad: 2,
          freeScroll: true,
          imagesLoaded: true,
          draggable: true,
          cellAlign: 'center',
          wrapAround: true,
          pageDots: false,
          contain: true,
          prevNextButtons:  true,
          initialIndex: 0,
          arrowShape: arrowShape,
          adaptiveHeight: true,
          selectedAttraction: 0.01,
          friction: 0.15
        });
        slider.on('settle.flickity', function () {
          slider.flickity('resize');
        });
         const $slides = $section.find('.collection_slider_header');
         slider.on( 'change.flickity', function() {
           
            $slides.each((index, slide) => {
              if ($(slide).hasClass('is-selected')) { // When active slide
                 var tag = $(slide).attr("data-handle");
                $sliderEl = $section.find('[data-slider].'+tag+'_slider');
                $section.find(".collection-handle-btn").removeClass("is-active");
                $section.find(".featured-collection-slider").addClass("is-hidden");
                $sliderEl.parent().removeClass("is-hidden");
                Shopify.theme.jsFeaturedCollectionsSlider.createSlider($sliderEl,$section);
               slider.flickity('resize');
                return false;
              }
            });
          });
          slider.on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
            slider.flickity( 'select', cellIndex );
            var tag = $(cellElement).attr("data-handle");
            $sliderEl = $section.find('[data-slider].'+tag+'_slider');
            $section.find(".collection-handle-btn").removeClass("is-active");
            $section.find(".featured-collection-slider").addClass("is-hidden");
            $sliderEl.parent().removeClass("is-hidden");
            Shopify.theme.jsFeaturedCollectionsSlider.createSlider($sliderEl,$section);
          });
    
      },
      unload: function ($section) {
        let $slider = $section.find('.flickity-enabled');
        $slider.flickity('destroy');
      }
    }
  
    /******/
  })()
    ;